import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { planMutationKeys, planQueryKeys } from '../constants'
import { customQueryClient } from '../../config/query-client'

export const useUpdatePlanFolderDetailsMutation = (options) => {
  const handleMutation = async ({ folderId, folderDetails }) => {
    const config = {
      method: 'patch',
      data: folderDetails
    }
    const { data } = await api(`/api/v2/planFolders/${folderId}`, config)

    return data
  }

  const invalidateRelatedQueries = (folderId) => {
    customQueryClient.invalidateQueries({
      queryKey: [planQueryKeys.GET_PLAN_FOLDER_DETAILS, folderId]
    })

    customQueryClient.invalidateQueries({
      queryKey: [planQueryKeys.GET_PLANS_TREE_QUERY]
    })
    customQueryClient.invalidateQueries({
      queryKey: [planQueryKeys.GET_PLANS_TREE_INFINITY_QUERY]
    })
    customQueryClient.invalidateQueries({
      queryKey: [planQueryKeys.GET_PLANS_CHILDREN_TREE_QUERY]
    })

    // renaming a folder changes the relative path of every plan nested under
    // it, not just folderId itself, so invalidate every cached relative path
    customQueryClient.invalidateQueries({
      queryKey: [planQueryKeys.GET_RELATIVE_PLAN_PATH]
    })
  }

  return useMutation({
    mutationKey: [planMutationKeys.UPDATE_PLAN_FOLDER_DETAILS],
    mutationFn: handleMutation,
    retry: 0,
    ...options,
    onSuccess: (data, variables, context) => {
      invalidateRelatedQueries(variables.folderId)

      options?.onSuccess?.(data, variables, context)
    },
    onError: (error, variables, context) => {
      options?.onError?.(error, variables, context)
    }
  })
}

// Screenshot 2023-05-25 at 10.26.07
// Screenshot 2023-05-24 at 18.54.14
